import React from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import { InfiniteScroll } from "nq-component";

import BaseListPage from "../../../../../base/BaseListPage";
import Earning from "./DisbursementAction/DisbursementEarnings/Earning";
import EarningEdit from "./DisbursementAction/DisbursementEarnings/EarningEdit";
import { v4 as uuidv4 } from "uuid";
import DisbursementsPresenter from "../../DisbursementsPresenter";
import Progress from "../../../../../components/Progress";

export default class DisbursementEarningTable extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new DisbursementsPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      object: [],
      objects: [],
      limit: 10,
      current: 1,
      count: 0,
      earningData: [],
      displayList: [],
      objectID: "",
    };
    this.handleAddList = this.handleAddList.bind(this);
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.objectID !== this.props.objectID) {
      this.setState({
        objectID: this.props.objectID,
      });
    }
    if (prevProps.childData !== this.props.childData) {
      this.setState({
        object: this.props.childData,
      });
    }
    if (prevState.object !== this.state.object) {
      // }
      if (this.state.object.length > 0) {
        this.props.earningData(this.state.object);
      }
    }
  }

  getCollectionName() {
    return "earning";
  }
  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  handleAddList(data) {
    this.setState((prevState) => ({
      displayList: [...prevState.displayList, data],
    }));
  }

  Earning = (earning, isUpdate = false) => {
    this.setState((prevState) => {
      let objects;
      if (isUpdate) {
        objects = prevState.object.map((obj) =>
          obj.description === earning.description ? { ...obj, ...earning } : obj
        );
      } else {
        if (this.state.objectID === "") {
          const objectID = uuidv4();
          this.setState({ objectID });
          const newErning = { ...earning, disbursementNum: objectID };
          this.props.getObjectId(newErning.disbursementNum);
          objects = [...prevState.object, newErning];
        } else {
          const newErning = {
            ...earning,
            disbursementNum: this.state.objectID,
          };
          objects = [...prevState.object, newErning];
        }
      }
      return { object: objects };
    });
  };

  handleObjectData = (data) => {
    dialog.fire({
      html: <EarningEdit Earning={this.Earning} object={data} />,
      footer: false,
    });
  };

  disbursementEarning = () => {
    dialog.fire({
      html: <Earning Earning={this.Earning} />,
      footer: false,
    });
  };

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { object, count, limit, current } = this.state;
    if (!schema) return <Progress />;
    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll className="h-100">
            <div className="p-3 p-lg-4">
              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <div className="d-flex align-items-center justify-content-center">
                  <div style={{ marginLeft: "auto" }}>
                    <Button type="button" onClick={this.disbursementEarning}>
                      <i className="bi bi-plus-lg" /> Add
                    </Button>
                  </div>
                </div>
                <label>
                  <b>Earnings</b>
                </label>
              </div>

              <Table
                objectData={this.handleObjectData}
                fields={schema.fields}
                objects={object}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                collection={schema}
                actionsList={[
                  {
                    label: "Edit",
                    actionType: "object",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["Id", "Updated At"]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}
